export default "/images/af446a761c2e8fc5a3cab7c491122ce1.avif";